import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {default as en} from './translations/en.json'
import {default as nl} from './translations/nl.json'
import {default as de} from './translations/de.json'

Vue.use(VueI18n)

const languages = {
  en, nl, de
}

const dateTimeFormat = {
  date: {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  }
}

const dateTimeFormats = {}
Object.keys(languages).forEach(key => {
  dateTimeFormats[key] = dateTimeFormat;
})

const currencyFormat = {
  style: 'currency', currency: 'EUR'
}

const numberFormats = {}
Object.keys(languages).forEach(key => {
  numberFormats[key] = { currency: currencyFormat };
})

export default new VueI18n({
  locale: 'en',
  messages: languages,
  dateTimeFormats,
  numberFormats
})
